export function formatErrorMessage(error) {
    if (typeof error === 'string') {
        return error;
    } else if (error instanceof Error) {
        return error.message;
    } else if (typeof error === 'object') {
        try {
        return JSON.stringify(error);
        } catch {
        return 'An unknown error occurred';
        }
    } else {
        return 'An unknown error occurred';
    }
}